import React from "react";
import { View, FlatList, Pressable, StyleSheet } from "react-native";
import BottomSheet from "@components/ds/BottomSheet";
import { C, RText, Check } from "../theme";

/**
 * Pick-one sheet behind a header dropdown (locality, filter): one row per
 * option with its count right after the name, the selected one ticked.
 * Picking closes the sheet.
 * @param options [{ key, label, count }] — `count` null hides the bubble
 */
const OptionSheet = ({
  visible,
  title,
  options = [],
  selected,
  onSelect,
  onClose,
  testID,
}) => (
  <BottomSheet visible={visible} title={title} onClose={onClose}>
    <FlatList
      testID={testID}
      data={options}
      keyExtractor={(option) => String(option.key)}
      renderItem={({ item }) => {
        const active = item.key === selected;
        return (
          <Pressable
            testID={`${testID}-${item.key}`}
            onPress={() => onSelect(item.key)}
            style={[styles.row, active && styles.rowActive]}
          >
            <RText
              size={14}
              weight={active ? 700 : 500}
              color={active ? C.chipRed : C.ink}
              style={styles.label}
              numberOfLines={1}
            >
              {item.label}
            </RText>
            {item.count != null ? (
              <View style={[styles.bubble, active && styles.bubbleActive]}>
                <RText size={11} weight={700} color={C.surface}>
                  {String(item.count)}
                </RText>
              </View>
            ) : null}
            <View style={styles.grow} />
            <View style={[styles.tick, active && styles.tickActive]}>
              {active ? <Check size={12} /> : null}
            </View>
          </Pressable>
        );
      }}
    />
  </BottomSheet>
);

export default OptionSheet;

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingVertical: 14,
    paddingHorizontal: 12,
    borderRadius: 10,
  },
  rowActive: { backgroundColor: C.chipRedBg },
  // Shrinks for a long name; the count stays right after it.
  label: { flexShrink: 1 },
  grow: { flex: 1 },
  bubble: {
    minWidth: 22,
    height: 22,
    borderRadius: 11,
    paddingHorizontal: 6,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: C.muted,
  },
  bubbleActive: { backgroundColor: C.chipRed },
  tick: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 1.5,
    borderColor: C.border,
    alignItems: "center",
    justifyContent: "center",
  },
  tickActive: { backgroundColor: C.chipRed, borderColor: C.chipRed },
});
